import { downloadPacks } from "@/mocks/home";

export default function DownloadCta() {
  return (
    <section id="download" className="mx-auto w-full max-w-[1440px] px-4 pb-14 md:px-6 md:pb-20">
      <div className="relative overflow-hidden rounded-xl bg-accent-500 px-5 py-8 md:px-10 md:py-10">
        <div className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-accent-300/50" />
        <div className="pointer-events-none absolute -bottom-16 left-1/3 h-44 w-44 rounded-full bg-primary-300/30" />

        <div className="relative flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-xl">
            <span className="flex items-center gap-2 text-xs tracking-[0.22em] text-accent-900">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-inbox-archive-line" />
              </span>
              归档下载 · 入口
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              把整个仓库的目录带回去，离线也能慢慢整理
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-accent-950/80">
              目录、索引清单与来源对照表按周打包，下载后即可对照浏览，省去一页页翻找的时间。
            </p>
            <div className="mt-6 flex flex-wrap gap-2.5">
              <a
                href="#download"
                className="relative flex items-center gap-2 overflow-hidden rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-900 cursor-pointer whitespace-nowrap"
              >
                <span className="pointer-events-none absolute inset-y-0 left-0 w-1/3 -skew-x-12 bg-white/15 animate-hl-shine" />
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-download-2-line text-base" />
                </span>
                下载本周归档包
              </a>
              <a
                href="#collections"
                className="flex items-center gap-2 rounded-md border border-foreground-950/25 px-5 py-2.5 text-sm font-medium text-foreground-950 transition-colors hover:bg-foreground-950/10 cursor-pointer whitespace-nowrap"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-folder-open-line text-base" />
                </span>
                先看专题合集
              </a>
            </div>
          </div>

          <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-3 lg:max-w-xl">
            {downloadPacks.map((pack) => (
              <a
                key={pack.name}
                href="#download"
                className="group flex flex-col justify-between rounded-lg border border-foreground-950/12 bg-background-50/85 p-4 transition-colors hover:bg-background-50 cursor-pointer"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-foreground-950 text-background-50">
                  <i className={`${pack.icon} text-lg`} />
                </span>
                <div className="mt-3">
                  <p className="text-sm font-medium text-foreground-950">{pack.name}</p>
                  <p className="mt-1 text-[11px] text-foreground-500">
                    {pack.format} · {pack.size}
                  </p>
                </div>
                <span className="mt-3 flex items-center gap-1 text-[11px] text-primary-600">
                  点击下载
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}